import React, { useEffect, useState } from 'react';
import Formulario from './ColaboradorForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function Colaborador(props) {
    const { loader, modulo, 
        detalleProducto, detalleColaborador, 
        registroColaborador, detalleColab,
        modificarColaborador, lectura, listaTipoMO,
        agregarLinea, eliminarLinea, agregarLineaNueva,
        eliminarLineaNueva
    } = props;        
        
    useEffect(() => {
        const { match, leer, getModulo, listarTipoMO, limpiar } = props;
        const id = match.params.id;
        if (id) {
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        getModulo(periodo[5], periodo[4]);
        listarTipoMO();
        limpiar();
    }, [])

    const [crear, setCrear] = useState(true);

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar colaborador' : 'Crear colaborador';
    
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver colaborador';
    }

    return (
        <LoadMask loading={loader} dark>
            <Formulario
                registroColaborador = {registroColaborador}
                modificarColaborador = {modificarColaborador}
                crear = {crear}
                titulo = {titulo}
                editar = {editar}
                modulo = {modulo}
                bloqueo = {disabled}
                detalleProducto = {detalleProducto}
                detalleColaborador = {detalleColaborador}
                detalleColab = {detalleColab}
                lectura = {lectura}
                listaTipoMO = {listaTipoMO}
                agregarLinea = {agregarLinea}
                eliminarLinea = {eliminarLinea}
                agregarLineaNueva = {agregarLineaNueva}
                eliminarLineaNueva = {eliminarLineaNueva}
            />
        </LoadMask>
    );
}

export default Colaborador;